import FadeInSection from "../../../components/feature/FadeInSection";

const features = [
  {
    icon: "ri-robot-line",
    title: "AI-Driven Intelligence",
    desc: "Agent Ben leverages cutting-edge AI to understand, analyze, and act on your data automatically — no manual input required.",
  },
  {
    icon: "ri-file-list-3-line",
    title: "Statement Parsing",
    desc: "Upload bank statements and let Agent Ben extract every transaction, categorize it, and deliver clean, ready-to-import results.",
  },
  {
    icon: "ri-time-line",
    title: "Saves Hours Daily",
    desc: "What takes your team 15 minutes per document, Agent Ben handles in 15 seconds. Get your time back and focus on what matters.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Accurate & Reliable",
    desc: "With 98%+ accuracy on data extraction and reconciliation, Agent Ben delivers results you can trust every single time.",
  },
  {
    icon: "ri-download-cloud-line",
    title: "Instant Exports",
    desc: "Export your processed data instantly to CSV and integrate with platforms like QuickBooks, Xero, or any accounting software.",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "Always Available",
    desc: "Agent Ben is on 24/7 — no downtime, no delays, no sick days. Your digital agent is always ready when you need it.",
  },
];

export default function AboutSection() {
  return (
    <section id="about" className="bg-white py-24 px-6">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <FadeInSection>
          <div className="text-center mb-16">
            <span className="inline-block text-xs font-semibold uppercase tracking-widest text-[#3b6fd4] mb-3">
              About Agent Ben
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-[#0f2559] mb-4">
              Built to work.{" "}
              <span className="text-slate-400">Not to slow you down.</span>
            </h2>
            <p className="text-slate-500 text-base max-w-xl mx-auto leading-relaxed">
              Agent Ben is your AI-powered digital assistant designed to eliminate repetitive data work and give your team back the time they deserve.
            </p>
          </div>
        </FadeInSection>

        {/* Feature grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((f, i) => (
            <FadeInSection key={f.title} delay={i * 80}>
              <div className="bg-[#f5f8ff] border border-[#dce6f7] rounded-xl p-6 hover:border-[#3b6fd4]/50 hover:bg-[#edf2ff] transition-all duration-300 group h-full">
                <div className="w-10 h-10 flex items-center justify-center bg-[#0f2559]/10 rounded-lg mb-4 group-hover:bg-[#0f2559]/15 transition-colors duration-300">
                  <i className={`${f.icon} text-[#0f2559] text-lg`} />
                </div>
                <h3 className="text-[#0f2559] font-semibold text-sm mb-2">{f.title}</h3>
                <p className="text-slate-500 text-xs leading-relaxed">{f.desc}</p>
              </div>
            </FadeInSection>
          ))}
        </div>
      </div>
    </section>
  );
}
